export type FeedbackKind = "issue" | "suggestion";
export type FeedbackApp = "studio" | "tuner";

export interface FeedbackItem {
  id: string;
  kind: FeedbackKind;
  message: string;
  app: FeedbackApp;
  pageUrl: string | null;
  userAgent: string | null;
  createdAt: string;
}

export function feedbackFromJson(json: Record<string, unknown>): FeedbackItem {
  return {
    id: json.id as string,
    kind: json.kind as FeedbackKind,
    message: (json.message as string | undefined) ?? "",
    app: json.app as FeedbackApp,
    pageUrl: (json.page_url as string | null | undefined) ?? null,
    userAgent: (json.user_agent as string | null | undefined) ?? null,
    createdAt: (json.created_at as string | undefined) ?? "",
  };
}
